import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import type { Swiper as SwiperType } from "swiper";
// eslint-disable-next-line import/no-unresolved
import { Autoplay } from "swiper/modules";
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from "swiper/react";
import { BodyStyle, SlideStyle, StyledCarousel, StyledTitleContainer } from "./Carousel.styles";
import { WidgetElement } from "./MinorComponents/CarouselWidget.component";
import { TitleTypography } from "./Typography";
import { useLanguageStore } from "../../stores";

type IProps = {
  carouselData: WidgetElement[],
  onSwipeSetIstance: (state: SwiperType) => void,
  handleRedirectUrl: () => string,
  isLinkRelative?: boolean
}

export const Carousel = ({ carouselData, onSwipeSetIstance, handleRedirectUrl, isLinkRelative }: IProps) => {
  const language = useLanguageStore(state => state.language)?.id;
  const [activeSlide, setActiveSlide] = useState<number | null>(null);
  const onSetActiveSlide = (state: SwiperType) => {
    setActiveSlide(state.activeIndex);
    onSwipeSetIstance(state);
  };
  const isActiveSlide = (index: number) => activeSlide === index;

  return (
    <BodyStyle>
      <StyledCarousel
        autoplay={ {
          delay: 7000,
          disableOnInteraction: true

        } }
        modules={ [Autoplay] }
        onSwiper={ onSetActiveSlide }
        onActiveIndexChange={ onSetActiveSlide }
      >
        { carouselData?.map((card: WidgetElement, i) => (
          <SwiperSlide
            key={ `carousel-slide-${i}--${language}` }
            aria-hidden={ isActiveSlide(i) ? false : true }
            tabIndex={ isActiveSlide(i) ? 0 : -1 }
          >
            { isLinkRelative ? (
              // link interno: navigazione SPA react-router (mantiene lo stato Zustand)
              <RouterLink style={ { textDecoration: "none" } }
                to={ handleRedirectUrl() }
                tabIndex={ isActiveSlide(i) ? 0 : -1 }
              >
                <StyledTitleContainer>
                  <TitleTypography >
                    { card.title }
                  </TitleTypography>
                </StyledTitleContainer>

                <SlideStyle imageUrl={ card.coverPublicURL } />
              </RouterLink>
            ) : (
              <a style={ { textDecoration: "none" } }
                href={ handleRedirectUrl() }
                target="_blank"
                rel="noopener noreferrer"
                tabIndex={ isActiveSlide(i) ? 0 : -1 }
              >
                <StyledTitleContainer>
                  <TitleTypography >
                    { card.title }
                  </TitleTypography>
                </StyledTitleContainer>

                <SlideStyle imageUrl={ card.coverPublicURL } />
              </a>
            ) }
          </SwiperSlide>
        )) }

      </StyledCarousel>
    </BodyStyle>
  );
};
